
(function () {
  'use strict';

  var app = document.getElementById('hpaApp');
  if (!app) return;

  var STORAGE_KEY = 'hpa.improved.session.v1';
  var steps = ['1', '2', '3', '4', '5', '6'];
  var stepNames = {
    '1': 'Physiology',
    '2': 'Concerns',
    '3': 'Medical',
    '4': 'Biomarkers',
    '5': 'Baseline',
    '6': 'Review'
  };
  var unitPairs = {
    weight: { metric: 'kg', imperial: 'lbs', input: 'hpaWeight', toImperial: function (v) { return v * 2.20462; }, toMetric: function (v) { return v / 2.20462; }, metricRange: [30, 300], imperialRange: [66, 660] },
    height: { metric: 'cm', imperial: 'in', input: 'hpaHeight', toImperial: function (v) { return v / 2.54; }, toMetric: function (v) { return v * 2.54; }, metricRange: [120, 220], imperialRange: [47, 87] },
    water: { metric: 'L', imperial: 'oz', input: 'hpaWaterIntake', toImperial: function (v) { return v * 33.814; }, toMetric: function (v) { return v / 33.814; }, metricRange: [0, 10], imperialRange: [0, 338] }
  };
  var concernDefs = {
    gut: {
      label: 'Gut health / SIBO / IBS',
      desc: 'Bloating, bowel irregularity, food sensitivity, methane or hydrogen overgrowth.',
      symptoms: ['Bloating after meals', 'Irregular bowel movements', 'Food sensitivities', 'Abdominal discomfort', 'Excess gas']
    },
    mcas: {
      label: 'MCAS / histamine intolerance',
      desc: 'Food or environmental reactivity, flushing, hives, congestion, headaches.',
      symptoms: ['Skin reactions', 'Food / environmental reactivity', 'Headaches or migraines', 'Nasal congestion', 'Anxiety on exposure']
    },
    cognition: {
      label: 'Brain fog / cognitive function',
      desc: 'Mental fatigue, focus issues, memory complaints, post-illness cognitive decline.',
      symptoms: ['Mental fatigue by midday', 'Word-finding difficulty', 'Short-term memory issues', 'Difficulty focusing', 'Slower processing speed']
    },
    recovery: {
      label: 'Athletic performance / recovery',
      desc: 'Training load, soreness, lactate clearance, endurance, recovery windows.',
      symptoms: ['Persistent muscle soreness', 'Slow recovery between sessions', 'Drop in performance', 'Elevated resting HR', 'Sleep disrupted by training']
    },
    inflammation: {
      label: 'Inflammation / autoimmune',
      desc: 'Joint pain, autoimmune diagnosis, flares, elevated inflammatory markers.',
      symptoms: ['Joint pain or stiffness', 'Morning stiffness over 30 min', 'Fatigue with flares', 'Skin involvement', 'Elevated inflammatory markers']
    },
    longevity: {
      label: 'Longevity / anti-aging',
      desc: 'Preventive use, mitochondrial support, oxidative stress, vitality.',
      symptoms: ['Recovery from exertion', 'Skin quality / elasticity', 'Energy stability', 'Stress resilience', 'General vitality']
    },
    kidney: {
      label: 'Kidney support',
      desc: 'CKD, creatinine changes, dialysis context, kidney stone history.',
      symptoms: ['Fatigue', 'Fluid retention / swelling', 'Frequency / urgency changes', 'Elevated creatinine on labs', 'Blood pressure issues']
    },
    metabolic: {
      label: 'Blood sugar / metabolic',
      desc: 'Insulin resistance, type 2 diabetes, metabolic syndrome, NAFLD.',
      symptoms: ['Post-meal energy crashes', 'Sweet / carb cravings', 'Difficulty losing weight', 'Elevated fasting glucose', 'Liver enzyme elevation']
    },
    emf: {
      label: 'EMF / radiation exposure',
      desc: 'Frequent flying, occupational exposure, post-radiation support.',
      symptoms: ['Fatigue after flying', 'Headaches near devices', 'Sleep disruption near tech', 'Skin sensitivity', 'Post-radiation recovery']
    }
  };
  var choiceLabels = {
    sex: {
      female: 'Female',
      male: 'Male',
      other: 'Other / prefer not to say'
    },
    activity: {
      sedentary: 'Sedentary - desk job, minimal exercise',
      light: 'Light - walks, occasional exercise',
      moderate: 'Moderate - 3 to 4 sessions per week',
      very_active: 'Very active - 5+ sessions per week',
      athlete: 'Athlete - daily or competitive training'
    },
    waterSource: {
      tap: 'Municipal tap',
      filtered: 'Filtered - carbon or faucet',
      ro: 'Reverse osmosis',
      distilled: 'Distilled',
      bottled: 'Bottled spring',
      well: 'Well water'
    },
    duration: {
      lt3mo: 'Less than 3 months',
      '3to12mo': '3 to 12 months',
      '1to3yr': '1 to 3 years',
      gt3yr: 'More than 3 years'
    }
  };

  var state = loadState() || {
    currentStep: 'gate',
    units: { weight: 'kg', height: 'cm', water: 'L' },
    concerns: [],
    data: {}
  };

  var els = {
    error: app.querySelector('[data-hpa="error"]'),
    progress: app.querySelector('[data-hpa="progress"]'),
    progressFill: app.querySelector('[data-hpa="progressFill"]'),
    progressTitle: app.querySelector('[data-hpa="progressTitle"]'),
    stepChips: app.querySelector('[data-hpa="stepChips"]'),
    savedLabel: app.querySelector('[data-hpa="savedLabel"]'),
    concernList: app.querySelector('[data-hpa="concernList"]'),
    concernCounter: app.querySelector('[data-hpa="concernCounter"]'),
    severityHost: app.querySelector('[data-hpa="severityHost"]'),
    durationHost: app.querySelector('[data-hpa="durationHost"]'),
    reviewHost: app.querySelector('[data-hpa="reviewHost"]'),
    submit: app.querySelector('[data-hpa="submit"]'),
    consent: app.querySelector('[data-hpa="consent"]'),
    consentWrap: app.querySelector('[data-hpa="consentWrap"]'),
    finalEmail: app.querySelector('[data-hpa="finalEmail"]'),
    refId: app.querySelector('[data-hpa="refId"]')
  };

  function loadState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }

  function saveState() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    if (els.savedLabel) {
      els.savedLabel.textContent = 'Saved locally';
      els.savedLabel.style.opacity = '1';
    }
  }

  function q(sel, scope) { return (scope || app).querySelector(sel); }
  function qa(sel, scope) { return Array.prototype.slice.call((scope || app).querySelectorAll(sel)); }
  function labelForChoice(name, value) {
    return (choiceLabels[name] && choiceLabels[name][value]) || value || '';
  }
  function niceList(items) {
    items = (items || []).filter(Boolean);
    if (!items.length) return 'Not provided';
    return items.join(', ');
  }
  function valuesToLabels(name) {
    var values = state.data[name] || [];
    if (!Array.isArray(values) || !values.length) return [];
    return values.map(function (value) {
      var input = q('input[name="' + name + '"][value="' + value + '"]');
      var label = input && input.closest('label');
      var title = label && label.querySelector('.hpa-choice-title');
      return title ? title.textContent.trim() : value;
    });
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }
  function numberOrNull(value) {
    var n = parseFloat(value);
    return isFinite(n) ? n : null;
  }

  function createStepChips() {
    els.stepChips.innerHTML = steps.map(function (step) {
      return '<span class="hpa-step-chip" data-chip="' + step + '">' + step + '. ' + stepNames[step] + '</span>';
    }).join('');
  }

  function createConcernCards() {
    els.concernList.innerHTML = Object.keys(concernDefs).map(function (key) {
      var def = concernDefs[key];
      return '<button type="button" class="hpa-concern-card" data-concern="' + key + '" aria-pressed="false">' +
        '<span></span><span><span class="hpa-concern-title">' + escapeHtml(def.label) + '</span>' +
        '<span class="hpa-concern-desc">' + escapeHtml(def.desc) + '</span></span></button>';
    }).join('');
  }

  function showError(message) {
    els.error.textContent = message;
    els.error.setAttribute('data-show', 'true');
    els.error.focus({ preventScroll: true });
    window.scrollTo({ top: app.offsetTop, behavior: 'smooth' });
  }

  function clearError() {
    els.error.removeAttribute('data-show');
    els.error.textContent = '';
  }

  function showStep(step) {
    collectVisible();
    state.currentStep = step;
    saveState();
    qa('.hpa-step').forEach(function (section) {
      section.setAttribute('data-active', section.getAttribute('data-step') === String(step) ? 'true' : 'false');
    });
    clearError();
    updateProgress();
    if (step === '6') renderReview();
    syncState();
    window.scrollTo({ top: app.offsetTop, behavior: 'smooth' });
  }

  function updateProgress() {
    var idx = steps.indexOf(state.currentStep);
    if (idx < 0) {
      els.progress.hidden = true;
      return;
    }
    els.progress.hidden = false;
    var pct = Math.round(((idx + 1) / steps.length) * 100);
    els.progressFill.style.width = pct + '%';
    els.progressTitle.textContent = 'Step ' + (idx + 1) + ' of ' + steps.length + ': ' + stepNames[state.currentStep];
    qa('[data-chip]').forEach(function (chip) {
      var chipStep = chip.getAttribute('data-chip');
      var chipIdx = steps.indexOf(chipStep);
      chip.classList.toggle('is-active', chipStep === state.currentStep);
      chip.classList.toggle('is-done', chipIdx < idx);
    });
  }

  function renderSeverity() {
    els.severityHost.innerHTML = '';
    els.durationHost.hidden = state.concerns.length === 0;

    state.concerns.forEach(function (key) {
      var def = concernDefs[key];
      var rows = def.symptoms.map(function (sym, i) {
        var name = 'sev_' + key + '_' + i;
        var value = state.data[name] || '0';
        return '<div class="hpa-field">' +
          '<label class="hpa-label" for="' + name + '">' + escapeHtml(sym) + '</label>' +
          '<div class="hpa-slider-row">' +
          '<input type="range" id="' + name + '" name="' + name + '" min="0" max="10" value="' + escapeHtml(value) + '" data-slider />' +
          '<span class="hpa-slider-value">' + escapeHtml(value) + '</span>' +
          '</div>' +
          '</div>';
      }).join('');

      els.severityHost.insertAdjacentHTML('beforeend',
        '<div class="hpa-severity-block" data-severity-block="' + key + '">' +
        '<div class="hpa-severity-title"><strong>' + escapeHtml(def.label) + '</strong><span class="hpa-severity-score" data-severity-score="' + key + '">Average 0/10</span></div>' +
        rows +
        '</div>'
      );
    });
    updateSliderValues();
    updateSeverityScores();
  }

  function updateConcernVisuals() {
    qa('[data-concern]').forEach(function (card) {
      var selected = state.concerns.indexOf(card.getAttribute('data-concern')) >= 0;
      card.setAttribute('data-selected', selected ? 'true' : 'false');
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    els.concernCounter.textContent = state.concerns.length + ' of 2 selected';
  }

  function updateSliderValues() {
    qa('[data-slider]').forEach(function (slider) {
      var valueEl = slider.parentElement.querySelector('.hpa-slider-value');
      if (valueEl) valueEl.textContent = slider.value;
    });
  }

  function updateSeverityScores() {
    state.concerns.forEach(function (key) {
      var values = concernDefs[key].symptoms.map(function (_, i) {
        return numberOrNull(state.data['sev_' + key + '_' + i]) || 0;
      });
      var avg = values.length ? values.reduce(function (sum, v) { return sum + v; }, 0) / values.length : 0;
      var score = q('[data-severity-score="' + key + '"]');
      if (score) score.textContent = 'Average ' + avg.toFixed(1) + '/10';
    });
  }

  function setUnit(key, nextUnit, convertValue) {
    var pair = unitPairs[key];
    var input = document.getElementById(pair.input);
    var previous = state.units[key];
    if (!pair || !input) return;

    var value = numberOrNull(input.value);
    if (value !== null && convertValue && previous !== nextUnit) {
      var converted = nextUnit === pair.imperial ? pair.toImperial(value) : pair.toMetric(value);
      input.value = Math.round(converted * 10) / 10;
      state.data[input.name] = input.value;
    }

    state.units[key] = nextUnit;
    var range = nextUnit === pair.imperial ? pair.imperialRange : pair.metricRange;
    input.min = range[0];
    input.max = range[1];
    updateUnitControls(key);
  }

  function updateUnitControls(key) {
    qa('[data-hpa="unitOption"][data-unit-key="' + key + '"]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-unit') === state.units[key] ? 'true' : 'false');
    });
  }

  function chooseUnit(key, unit) {
    setUnit(key, unit, true);
    collectVisible();
    saveState();
    syncState();
  }

  function collectVisible() {
    qa('input, select, textarea').forEach(function (el) {
      if (!el.name) return;
      if (el.type === 'checkbox') {
        if (el.name === 'consent') {
          state.data[el.name] = el.checked;
        } else {
          var values = qa('input[name="' + el.name + '"]:checked').map(function (checked) { return checked.value; });
          state.data[el.name] = values;
        }
      } else if (el.type === 'radio') {
        var checked = q('input[name="' + el.name + '"]:checked');
        if (checked) state.data[el.name] = checked.value;
      } else {
        state.data[el.name] = el.value;
      }
    });
  }

  function markInvalid(target, invalid) {
    var wrap = target.closest('.hpa-field') || target.closest('.hpa-choice-group') || target;
    if (wrap) wrap.classList.toggle('hpa-invalid', invalid);
  }

  function isHiddenField(el) {
    return !!(el.closest('[hidden]') || el.hidden);
  }

  function validateStep(step) {
    collectVisible();
    var section = q('.hpa-step[data-step="' + step + '"]');
    var missing = [];
    qa('.hpa-invalid', section).forEach(function (el) { el.classList.remove('hpa-invalid'); });

    qa('[data-required]', section).forEach(function (el) {
      if (isHiddenField(el)) return;
      var val = el.value;
      var invalid = !val;
      if (!invalid && el.type === 'number') {
        var n = numberOrNull(val);
        invalid = n === null || (el.min && n < parseFloat(el.min)) || (el.max && n > parseFloat(el.max));
      }
      markInvalid(el, invalid);
      if (invalid) missing.push(el.getAttribute('data-label') || el.name);
    });

    qa('[data-required-group]', section).forEach(function (group) {
      if (isHiddenField(group)) return;
      var name = group.getAttribute('data-required-group');
      var invalid = !q('input[name="' + name + '"]:checked', group);
      group.classList.toggle('hpa-invalid', invalid);
      if (invalid) missing.push(group.getAttribute('data-label') || name);
    });

    if (step === 'gate') {
      var email = q('#hpaEmail').value.trim();
      var emailBad = !!email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      markInvalid(q('#hpaEmail'), emailBad || !email);
      if (emailBad) missing.push('Valid checkout email');
    }

    if (step === '2' && state.concerns.length === 0) {
      missing.push('At least one primary concern');
    }

    if (step === '6' && !els.consent.checked) {
      els.consentWrap.classList.add('hpa-invalid');
      missing.push('Medical disclaimer consent');
    } else if (step === '6') {
      els.consentWrap.classList.remove('hpa-invalid');
    }

    return { ok: missing.length === 0, missing: missing };
  }

  function syncState() {
    collectVisible();
  }

  function filterConditions(query) {
    var normalized = String(query || '').trim().toLowerCase();
    var visibleCount = 0;
    qa('[data-condition-item]').forEach(function (item) {
      var text = item.textContent.toLowerCase();
      var show = !normalized || text.indexOf(normalized) >= 0;
      item.hidden = !show;
      if (show) visibleCount += 1;
    });
    var empty = q('[data-hpa="conditionEmpty"]');
    if (empty) empty.setAttribute('data-show', visibleCount ? 'false' : 'true');
  }

  function handleExclusiveCheckbox(input) {
    var group = input.closest('[data-exclusive-group]');
    if (!group || !input.checked) return;
    if (input.getAttribute('data-exclusive') === 'none') {
      qa('input[type="checkbox"]', group).forEach(function (other) {
        if (other !== input) other.checked = false;
      });
      return;
    }
    var none = q('input[data-exclusive="none"]', group);
    if (none) none.checked = false;
  }

  function renderReview() {
    collectVisible();
    var sex = labelForChoice('sex', state.data.sex);
    var activity = labelForChoice('activity', state.data.activity);
    var waterSource = labelForChoice('waterSource', state.data.waterSource);
    var duration = labelForChoice('duration', state.data.duration);
    var concerns = state.concerns.map(function (key) { return concernDefs[key].label; });
    var supplements = valuesToLabels('supplements');
    var conditionList = valuesToLabels('conditionList');
    var allergies = valuesToLabels('allergies');

    var cards = [
      { step: '1', title: 'Physiology', body: [
        state.data.age ? state.data.age + ' years' : '',
        sex,
        state.data.weight ? state.data.weight + ' ' + state.units.weight : '',
        state.data.height ? state.data.height + ' ' + state.units.height : '',
        activity,
        state.data.waterIntake ? state.data.waterIntake + ' ' + state.units.water + ' water/day' : '',
        waterSource
      ] },
      { step: '2', title: 'Concerns', body: concerns.concat(duration ? ['Duration: ' + duration] : []) },
      { step: '3', title: 'Medical context', body: [
        state.data.medications ? 'Medications: ' + state.data.medications : 'No medications listed',
        conditionList.length ? 'Conditions: ' + conditionList.join(', ') : 'No common conditions checked',
        state.data.conditions ? 'Condition notes: ' + state.data.conditions : '',
        allergies.length ? 'Allergies / intolerances: ' + allergies.join(', ') : 'No allergies or intolerances checked',
        state.data.allergyDetails ? 'Allergy details: ' + state.data.allergyDetails : '',
        supplements.length ? 'Supplements: ' + supplements.join(', ') : 'No supplements checked'
      ] },
      { step: '4', title: 'Biomarkers', body: biomarkerSummary() },
      { step: '5', title: 'Tracking baseline', body: [
        'Energy ' + (state.data.bl_energy || 5) + '/10',
        'Sleep ' + (state.data.bl_sleep || 5) + '/10',
        'Digestion ' + (state.data.bl_digestion || 5) + '/10',
        'Clarity ' + (state.data.bl_clarity || 5) + '/10',
        'Joint comfort ' + (state.data.bl_joints || 5) + '/10'
      ] }
    ];

    els.reviewHost.innerHTML = cards.map(function (card) {
      return '<article class="hpa-review-card"><h3>' + escapeHtml(card.title) +
        '<button type="button" class="hpa-edit" data-edit-step="' + card.step + '">Edit</button></h3>' +
        '<p>' + escapeHtml(niceList(card.body)) + '</p></article>';
    }).join('');
  }

  function biomarkerSummary() {
    var labels = {
      crp: 'hs-CRP', glucose: 'Fasting glucose', hba1c: 'HbA1c', vitaminD: 'Vitamin D',
      ferritin: 'Ferritin', homocysteine: 'Homocysteine', hrv: 'HRV', rhr: 'Resting HR', sleepScore: 'Sleep score'
    };
    return Object.keys(labels).filter(function (key) {
      return state.data[key];
    }).map(function (key) {
      return labels[key] + ': ' + state.data[key];
    });
  }

  function hydrate() {
    Object.keys(unitPairs).forEach(function (key) {
      setUnit(key, state.units[key] || unitPairs[key].metric, false);
    });

    Object.keys(state.data || {}).forEach(function (name) {
      var value = state.data[name];
      var fields = qa('[name="' + name + '"]');
      fields.forEach(function (field) {
        if (field.type === 'checkbox') {
          if (field.name === 'consent') field.checked = !!value;
          else field.checked = Array.isArray(value) && value.indexOf(field.value) >= 0;
        } else if (field.type === 'radio') {
          field.checked = field.value === value;
        } else {
          field.value = value;
        }
      });
    });
    if (els.submit) els.submit.disabled = !els.consent.checked;
    updateSliderValues();
    updateConcernVisuals();
    renderSeverity();
    syncState();
  }

  function bindEvents() {
    app.addEventListener('input', function (event) {
      if (event.target.matches('[data-hpa="conditionSearch"]')) {
        filterConditions(event.target.value);
      }
      if (event.target.matches('input, select, textarea')) {
        collectVisible();
        if (event.target.matches('[data-slider]')) {
          updateSliderValues();
          updateSeverityScores();
        }
        if (event.target === els.consent) {
          els.submit.disabled = !els.consent.checked;
          els.consentWrap.classList.toggle('hpa-invalid', false);
        }
        saveState();
        syncState();
      }
    });

    app.addEventListener('change', function (event) {
      if (event.target.matches('input, select, textarea')) {
        if (event.target.type === 'checkbox') {
          handleExclusiveCheckbox(event.target);
        }
        collectVisible();
        saveState();
        syncState();
      }
    });

    app.addEventListener('click', function (event) {
      var concern = event.target.closest('[data-concern]');
      if (concern) {
        var key = concern.getAttribute('data-concern');
        var idx = state.concerns.indexOf(key);
        if (idx >= 0) {
          state.concerns.splice(idx, 1);
        } else if (state.concerns.length < 2) {
          state.concerns.push(key);
        } else {
          showError('Select up to two concerns. Deselect one before adding another.');
          return;
        }
        clearError();
        updateConcernVisuals();
        renderSeverity();
        collectVisible();
        saveState();
        syncState();
        return;
      }

      var unitBtn = event.target.closest('[data-hpa="unitOption"]');
      if (unitBtn) {
        chooseUnit(unitBtn.getAttribute('data-unit-key'), unitBtn.getAttribute('data-unit'));
        return;
      }

      var editBtn = event.target.closest('[data-edit-step]');
      if (editBtn) {
        showStep(editBtn.getAttribute('data-edit-step'));
        return;
      }
    });

    q('[data-hpa="verifyBtn"]').addEventListener('click', function () {
      var result = validateStep('gate');
      if (!result.ok) {
        showError('Please complete: ' + result.missing.join(', '));
        return;
      }
      showStep('1');
    });

    qa('[data-hpa="next"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = state.currentStep;
        var result = validateStep(current);
        if (!result.ok) {
          showError('Please complete: ' + result.missing.join(', '));
          return;
        }
        var next = steps[steps.indexOf(current) + 1];
        if (next) showStep(next);
      });
    });

    qa('[data-hpa="back"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.currentStep === '1') {
          showStep('gate');
          return;
        }
        var prev = steps[steps.indexOf(state.currentStep) - 1];
        if (prev) showStep(prev);
      });
    });

    q('[data-hpa="skip"]').addEventListener('click', function () {
      collectVisible();
      saveState();
      showStep('5');
    });

    els.submit.addEventListener('click', function () {
      var result = validateStep('6');
      if (!result.ok) {
        showError('Please complete: ' + result.missing.join(', '));
        return;
      }
      els.submit.disabled = true;
      els.submit.innerHTML = '<span class="hpa-spinner"></span>Submitting';

      var refId = 'HPA-' + Date.now().toString(36).toUpperCase();
      var payload = {
        referenceId: refId,
        submittedAt: new Date().toISOString(),
        email: state.data.email,
        nexisOrder: state.data.nexisOrder,
        concerns: state.concerns,
        units: state.units,
        intake: state.data
      };
      console.log('Preview submission payload:', payload);

      window.setTimeout(function () {
        els.finalEmail.textContent = state.data.email || 'your checkout email';
        els.refId.textContent = refId;
        showStep('done');
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      }, 700);
    });
  }

  createStepChips();
  createConcernCards();
  bindEvents();
  hydrate();
  showStep(state.currentStep || 'gate');
})();